import styled from "styled-components";

export const StyledContainer = styled.div`
    padding: 8px 16px;
    margin-top: auto;
`;
